<template>
  <Modal
    centered
    :visible="visible"
    wrap-class-name="feiiplat-oauth-modal-wrapper"
    :body-style="{ width: '800px', height: '600px', padding: 0 }"
    :width="800"
    :title="modalTitle"
    :animated="false"
    :footer="null"
    :closable="step === opsStep.RESULT"
    @change="$emit('change', $event)"
  >
    <template v-if="step === opsStep.VIEW_INFO">
      <div class="title">注册和绑定</div>
      <div class="reason">注册绑定后，下次可以直接使用手机号登录</div>
      <RadioGroup v-model="useAccountType" style="display:block">
        <div :class="rowClasses">
          <div v-if="oauthData.platformUser" class="col-content">
            <div class="type-radio-box">
              <Radio :value="accountType.PLATFORM">绑定HiAR账号</Radio>
            </div>
            <UserInfo :user="oauthData.platformUser" />
          </div>
          <div v-if="oauthData.factoryUser" class="col-content">
            <div class="type-radio-box">
              <Radio :value="accountType.FEIIPLAT">使用授权信息创建</Radio>
            </div>
            <UserInfo :user="oauthData.factoryUser" />
          </div>
        </div>
      </RadioGroup>
      <div class="bottom-section">
        <Button
          :disabled="bindBtnDisabled"
          type="primary"
          shape="round"
          block
          class="submit-btn"
          @click="handleConfirm"
          >{{ oauthData.platformUser ? "确定" : "注册并绑定" }}</Button
        >
        <div
          v-if="!oauthData.platformUser"
          style="text-align:center;margin-top:24px"
        >
          <Checkbox v-model="acceptProtocol"
            >同意<a href="https://aryun.com/protocol/privacy" target="_blank">隐私协议</a>和<a
              href="https://aryun.com/protocol/hileia-service"
              target="_blank"
              >使用政策</a
            ></Checkbox
          >
        </div>
      </div>
    </template>
    <template v-else-if="step === opsStep.SET_PWD">
      <FormModel
        ref="formRef"
        :model="formModel"
        :rules="formRules"
        style="width: 368px;margin: 105px auto 0;"
      >
        <FormModelItem prop="password" class="check-form-row">
          <InputPassword
            size="large"
            v-model="formModel.password"
            :min-length="6"
            :max-length="18"
            placeholder="6-18个字符,包含字母、数字、@、_"
            allow-clear
            autoFocus
          />
        </FormModelItem>
        <FormModelItem prop="confirmPassword" class="check-form-row">
          <InputPassword
            size="large"
            v-model="formModel.confirmPassword"
            :min-length="6"
            :max-length="18"
            allow-clear
            placeholder="再次输入密码"
          />
        </FormModelItem>
      </FormModel>
      <div class="bottom-section">
        <BasicBtnGroup
          class="pwd-btn-group"
          @defClick="handleIgnorePwd"
          @primeClick="handleConfirmPwd"
        >
          <span slot="defContent" class="text-black">跳过</span>
        </BasicBtnGroup>
      </div>
    </template>
    <template v-else-if="step === opsStep.RESULT">
      <Result class="ops-result" status="success" title="恭喜你，绑定成功" />
    </template>
  </Modal>
</template>
<script>
import {
  Modal,
  Radio,
  Button,
  Result,
  FormModel,
  Input,
  Checkbox
} from 'ant-design-vue'
import BasicBtnGroup from '@/components/behavior/basic-btn-group/index.vue'
import UserInfo from './UserInfo.vue'

import { passwordValidators } from '@/utils/validators'
import { mapActions } from 'vuex'
import MD5 from 'crypto-js/md5'
import { PAGE_NAME } from '@/utils/constant'

const ACCOUNT_TYPE = Object.freeze({
  PLATFORM: 'PLATFORM',
  FEIIPLAT: 'FEIIPLAT'
})

const OPS_STEP = Object.freeze({
  VIEW_INFO: 'VIEW_INFO',
  SET_PWD: 'SET_PWD',
  RESULT: 'SUCCESS'
})

// 飞象Oauth2.0
export default {
  name: 'FeiiplatOauth',
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    /**
     * @type {{
     *  platformUser?: object,
     *  factoryUser?: object
     * }}
     */
    oauthData: {
      type: Object,
      required: true
    }
  },
  components: {
    Modal,
    Radio,
    RadioGroup: Radio.Group,
    Button,
    Result,
    FormModel,
    InputPassword: Input.Password,
    FormModelItem: FormModel.Item,
    UserInfo,
    BasicBtnGroup,
    Checkbox
  },
  data() {
    return {
      step: OPS_STEP.VIEW_INFO,
      acceptProtocol: false,
      useAccountType: this.oauthData.platformUser
        ? null
        : ACCOUNT_TYPE.FEIIPLAT,
      formModel: this.resetForm(),
      formRules: {
        password: passwordValidators,
        confirmPassword: [
          { required: true, message: '请确认密码' },
          {
            validator: (rule, val, cb) => {
              if (val !== this.formModel.password) {
                return Promise.reject('两次密码不一致')
              }
              return Promise.resolve()
            }
          }
        ]
      }
    }
  },
  computed: {
    rowClasses() {
      const { platformUser, factoryUser } = this.oauthData

      let accountCount = 0
      if (platformUser) {
        accountCount++
      }

      if (factoryUser) {
        accountCount++
      }

      return `row-cols-${accountCount}`
    },
    accountType() {
      return ACCOUNT_TYPE
    },
    opsStep() {
      return OPS_STEP
    },
    modalTitle() {
      return this.step === OPS_STEP.SET_PWD ? '设置密码' : null
    },
    bindBtnDisabled() {
      return (
        (this.oauthData.platformUser && this.useAccountType === null) ||
        !(this.oauthData.platformUser || this.acceptProtocol)
      )
    }
  },
  methods: {
    ...mapActions('oauth', ['bindOauthAccount']),
    ...mapActions('user', ['loginFromPlatformToken']),

    handleConfirm() {
      this.step = OPS_STEP.SET_PWD
      this.formModel = this.resetForm()
    },
    resetForm() {
      return {
        password: '',
        confirmPassword: ''
      }
    },
    handleConfirmPwd() {
      if (this.useAccountType !== ACCOUNT_TYPE.PLATFORM) {
        this.$refs.formRef
          .validate({ first: true })
          .then(() => {
            this.bindUser()
          })
          .catch(() => {})
      } else {
        this.bindUser()
      }
    },
    handleIgnorePwd() {
      this.formModel = this.resetForm()
      this.bindUser()
    },
    bindUser() {
      this.$nextTick(async () => {
        const oauthData = this.oauthData
        const data = {
          token: oauthData.token
        }

        const password = this.formModel.password

        if (this.useAccountType === ACCOUNT_TYPE.PLATFORM) {
          data.userId = oauthData.platformUser.userId
        }

        if (password) {
          data.password = MD5(password).toString()
        }

        try {
          const { token: platformToken } = await this.bindOauthAccount(data)

          this.step = OPS_STEP.RESULT
          this.$emit('success', platformToken)

          this.$nextTick(() => {
            this.$emit('change', false)
          })
        } catch (err) {
          this.$router.replace({ name: PAGE_NAME.Exception, query: { code: err.code, msg: err.message } })
          throw err
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import url(~@/styles/font.less);
::v-deep .feiiplat-oauth-modal-wrapper {
  & > .ant-modal {
    padding-bottom: 0;
    & > .ant-modal-content {
      border-radius: 16px;
      box-shadow: 0px 5px 30px 0px rgba(89, 132, 219, 0.08);
      border: 1px solid #edeff2;
      overflow: hidden;

      & .ant-modal-body {
        &::before {
          content: " ";
          display: table;
        }
      }

      & > .ant-modal-header {
        position: absolute;
        width: 100%;
      }
    }
  }

  .title {
    .regular-font(18);
    margin-top: 72px;
    margin-bottom: 16px;
    text-align: center;
    &::before {
      content: " ";
      display: table;
    }
  }

  .reason {
    .regular-font(16);
    text-align: center;
    color: #6a6d73;
    margin-bottom: 40px;
  }

  .row-cols {
    &-1 {
      display: block;
      width: 376px;
      margin: 0 auto;

      & > .col-content {
        & > .type-radio-box {
          display: none;
        }
      }
    }
    &-2 {
      display: flex;
      justify-content: center;
      & > .col-content {
        width: 320px;
        &:first-child {
          margin-right: 32px;
        }
        & > .type-radio-box {
          margin-bottom: 16px;
        }
      }
    }
  }

  .bottom-section {
    position: absolute;
    bottom: 66px;
    width: 100%;
    padding: 0 64px;
  }

  .pwd-btn-group {
    width: 50%;
    margin-left: auto;
  }

  .submit-btn {
    display: block;
    width: 368px;
    height: 50px;
    margin: 0 auto;
  }

  .ant-btn-primary {
    color: #fff;

    background: linear-gradient(
      154deg,
      #236cff 0%,
      rgba(35, 108, 255, 0.8) 100%
    );

    border-color: transparent;

    box-shadow: 0px 5px 10px 0px rgba(35, 108, 255, 0.5);

    &[disabled] {
      background: #8ab1ff;
      box-shadow: 0px 5px 10px 0px rgba(35, 108, 255, 0.5);
    }
  }

  .ant-radio-inner,
  .ant-checkbox-inner {
    border: 1px solid #236cff;
  }

  .ops-result {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    .anticon {
      font-size: 88px;
    }
  }
}
</style>
